/* eslint-disable import/prefer-default-export */
import { createContext } from 'react';

const FiberPptpContext = createContext({});
export default FiberPptpContext;
